export default "__VITE_ASSET__D2izZNu3__"